import { render } from "./PageFooter.vue?vue&type=template&id=2e7a12fc&scoped=true"
const script = {}

import "./PageFooter.vue?vue&type=style&index=0&id=2e7a12fc&scoped=true&lang=scss"

import exportComponent from "/data/apps/fbe-location-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7a12fc"]])

export default __exports__